export const ITEMS_PER_PAGE = 20;
export const SORT = 'sort';

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
